import { apiRequest } from './client';
import type {
  PermissionItem,
  Role,
  RoleCreatePayload,
  RoleUpdatePayload,
  UserRoleAssignPayload,
  UserWithRoles,
  UsersListResponse,
} from '../types/roles';

export function getRoles(accessToken: string): Promise<readonly Role[]> {
  return apiRequest<readonly Role[]>('/admin/roles', { token: accessToken });
}

export function getRole(roleId: string, accessToken: string): Promise<Role> {
  return apiRequest<Role>(`/admin/roles/${roleId}`, { token: accessToken });
}

export function createRole(payload: RoleCreatePayload, accessToken: string): Promise<Role> {
  return apiRequest<Role>('/admin/roles', { method: 'POST', body: payload, token: accessToken });
}

export function updateRole(roleId: string, payload: RoleUpdatePayload, accessToken: string): Promise<Role> {
  return apiRequest<Role>(`/admin/roles/${roleId}`, { method: 'PATCH', body: payload, token: accessToken });
}

export function deleteRole(roleId: string, accessToken: string): Promise<void> {
  return apiRequest<void>(`/admin/roles/${roleId}`, { method: 'DELETE', token: accessToken });
}

export function getPermissions(accessToken: string): Promise<readonly PermissionItem[]> {
  return apiRequest<readonly PermissionItem[]>('/admin/permissions', { token: accessToken });
}

export type ListUsersParams = {
  readonly page?: number;
  readonly page_size?: number;
};

export function getUsers(params: ListUsersParams = {}, accessToken: string): Promise<UsersListResponse> {
  const { page = 1, page_size = 50 } = params;
  const query = new URLSearchParams({ page: String(page), page_size: String(page_size) });
  return apiRequest<UsersListResponse>(`/admin/users?${query.toString()}`, { token: accessToken });
}

export function assignUserRoles(
  userId: string,
  payload: UserRoleAssignPayload,
  accessToken: string,
): Promise<UserWithRoles> {
  return apiRequest<UserWithRoles>(`/admin/users/${userId}/roles`, {
    method: 'PUT',
    body: payload,
    token: accessToken,
  });
}
